import { useEffect } from 'react';

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title
      ? `${title} | Gemstone Minerals`
      : 'Gemstone Minerals - Sacred Healing Crystals & Metaphysical Wellness';
  }, [title]);
};
